module.exports = __webpack_public_path__ + "img/requests.62c2ea2a.svg";